export const CUSTOMER_PROFILE = 1
export const A2P_TRUST_PRODUCT = 2
export const A2P_BRAND = 3
export const A2P_MESSAGING_SERVICE = 4
export const STIR_SHAKEN = 5
export const VOICE_INTEGRITY = 6
export const CNAM_BUNDLE = 7
export const ADDRESS_BUNDLE = 8
export const REGULATORY_BUNDLE = 9
export const INCOMING_NUMBER = 10
export const TOLL_FREE_VERIFICATION = 11
export const VERIFIED_CALLER_ID = 12
export const BRANDED_CALLER_ID = 13
export const RCS = 14

export const COMPLIANCE_BUNDLE_TYPES = {
    1: 'Customer Profile',
    2: 'A2P Trust Bundle',
    3: 'A2P Brand',
    4: 'Messaging Service',
    5: 'STIR/SHAKEN',
    6: 'Voice Integrity',
    7: 'CNAM Caller ID',
    8: 'Address',
    9: 'Regulatory Bundle',
    10: 'Incoming Number',
    11: 'Toll-Free Verification',
    12: 'Verified Caller ID',
    13: 'Branded Caller ID',
    14: 'RCS',
}
